module.exports = __webpack_public_path__ + "img/map-hq.8a233a76.jpg";